import { Button, Stack } from "@mui/material";
import React, { useState } from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import toast from "react-hot-toast";
import MenuImagePreview from "./AIMenuGeneration";
import { httpsCallable } from "firebase/functions";
import { functions } from "firebaseApp";
import ImagePreview from "components/images/ImagePreview";
import ImageAutoUploader from "ai-menu/ImageAutoUploader";
import GenerateMenuButton from "ai-menu/GenerateMenuButton";

export default function AIMenuGenerator({ image, setImage }) {

  const [generating, setGenerating] = useState();

  const handleGenerateMenu = async () => {
    try {
      setGenerating(true);
      const res = await httpsCallable(functions, "generateMenu")({
        base64Image: image.base64,
      });
      const data = res.data;
      console.log(data);
    } catch (error) {
      toast.error("Error generating menu.");
      console.log(error);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <Stack alignItems="center" spacing={1}>
      {/* <MenuImagePreview
        image={image}
        setImage={setImage}
        generating={generating}
      /> */}
      <ImageAutoUploader
        image={image}
        setImage={setImage}
        previewSize={250}
        onClick={() => setImage()}
      />
      
      <GenerateMenuButton 
        image={image}
      />
    </Stack>
  );
}
